import "./pagination.css";

const Pagination = ({ pages, currentPage, setCurrentPage }) => {
  const generatedPages = [];
  for (let i = 1; i <= pages; i++) {
    generatedPages.push(i);
  }
  return (
    <div className="pagination">
      <button
        onClick={() => setCurrentPage((current) => current - 1)}
        className="page- previous"
        disabled={currentPage === 1}
      >
        السابق
      </button>
      {generatedPages?.map((page) => (
        <div
          onClick={() => setCurrentPage(page)}
          className={currentPage === page ? "page- active" : "page-"}
          key={page}
        >
          {page}
        </div>
      ))}
      <button
        onClick={() => setCurrentPage((current) => current + 1)}
        className="page- next"
        disabled={currentPage === pages}
      >
        الآتى
      </button>
    </div>
  );
};

export default Pagination;
